import React from "react";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import logo from "../logo.svg";

const Footer = ({ supportEmail, setFeedbackOpen, children }) => {
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem("token");

  const handleLogoClick = () => {
    if (isLoggedIn) {
      navigate("/dashboard");
    } else {
      navigate("/");
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1">{children}</div>
      <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 mt-auto pt-8 pb-4">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
            {/* Logo */}
            <div className="flex flex-col items-center sm:items-start">
              <div
                className="flex items-center mb-4 cursor-pointer group"
                onClick={handleLogoClick}
              >
                <img
                  src={logo}
                  alt="ReelTale Logo"
                  className="h-10 mr-3 transition-transform group-hover:scale-105"
                />
                <Typography variant="h6" className="font-bold text-primary-600 dark:text-primary-400">
                  ReelTale
                </Typography>
              </div>
            </div>
            {/* LINKS Column */}
            <div>
              <Typography variant="subtitle1" className="font-bold mb-4 text-gray-900 dark:text-white">
                LINKS
              </Typography>
              <div className="flex flex-col gap-2">
                <a
                  href="/signup"
                  className="text-primary-600 dark:text-primary-400 no-underline hover:text-primary-700 dark:hover:text-primary-300 transition-colors"
                >
                  Sign Up
                </a>
                <a
                  href="/login"
                  className="text-primary-600 dark:text-primary-400 no-underline hover:text-primary-700 dark:hover:text-primary-300 transition-colors"
                >
                  Login
                </a>
                <a
                  href="/pricing"
                  className="text-primary-600 dark:text-primary-400 no-underline hover:text-primary-700 dark:hover:text-primary-300 transition-colors"
                >
                  Pricing
                </a>
              </div>
            </div>
            {/* SUPPORT Column */}
            <div>
              <Typography variant="subtitle1" className="font-bold mb-4 text-gray-900 dark:text-white">
                SUPPORT
              </Typography>
              <div className="flex flex-col gap-2">
                <a
                  href={`mailto:${supportEmail}`}
                  className="text-primary-600 dark:text-primary-400 no-underline hover:text-primary-700 dark:hover:text-primary-300 transition-colors"
                >
                  Contact Support
                </a>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setFeedbackOpen && setFeedbackOpen(true);
                  }}
                  className="text-primary-600 dark:text-primary-400 no-underline hover:text-primary-700 dark:hover:text-primary-300 transition-colors"
                >
                  Send Feedback
                </a>
                <a
                  href="https://www.termsfeed.com/live/08c28835-2830-41b2-b0e4-878dd57ef192"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-600 dark:text-primary-400 no-underline hover:text-primary-700 dark:hover:text-primary-300 transition-colors"
                >
                  Privacy Policy
                </a>
                <a
                  href="https://docs.google.com/document/d/e/2PACX-1vQYEC5goS1oewAFmq6h0-XwqOOn2BQB0cXI2n-H0awEzjQza59ba1VObhrOFXwU2uXyN8FVNj-VJV4B/pub"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-600 dark:text-primary-400 no-underline hover:text-primary-700 dark:hover:text-primary-300 transition-colors"
                >
                  Terms and Conditions
                </a>
              </div>
            </div>
          </div>
          <div className="mt-8 text-center text-sm text-gray-600 dark:text-gray-400">
            &copy; {new Date().getFullYear()} ReelTale. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
